module.exports = __webpack_public_path__ + "043808cfbb5fa961915ebb823ae65cdc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-14.png
// module id = 2124
// module chunks = 0